<div class="toggle-strip">
	<div class="toggle-group" *ngFor="let group of groups">
		<div class="group-title">{{ formatLabel(group.title) }}</div>
		<div class="group-options">
			<button type="button" class="option-btn" *ngFor="let option of group.options"
				[class.selected]="isSelected(group.title, option)" (click)="toggleOption(group.title, option)">
				{{ formatOption(option) }}
			</button>
		</div>
	</div>
</div>